import { useLazyQuery } from "@apollo/client";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { Company, MeQuery } from "../../__generated__/graphql";
import { useNavigate } from "react-router";
import usePersonStore, { PersonModel } from "../store/personStore";
import usePersonAuthStore from "../store/personAuthStore"
import { QUERY_ME } from "../../features/graphql/query/me/GetMe";
// import { CompanyTable } from "ft-shared-graphql/components/Tables";
// import { CompanyTable } from "../CompanyPages/components/CompanyTable";
import { useCompany } from "../../context/CompanyContext";

function transformToState(data: MeQuery): PersonModel {
    return {
        id: data.me?.id,
        name: `${data.me?.firstName} ${data.me?.lastName}`,
        company: {
            id: data.me?.company.id,
            name: data.me?.company.name ?? null,
            defaultLocation: (data.me?.defaultLocation as any),
        },
    }
}

function DashboardPage() {
    const navigate = useNavigate()
    const { setCompany } = useCompany();
    const roles = usePersonAuthStore((state) => state.roles)
    const [queryMe] = useLazyQuery(QUERY_ME, { notifyOnNetworkStatusChange: true })
    const setPersonStoreState = usePersonStore(state => state.setState)
    useEffect(() => {
        queryMe().then(response => setPersonStoreState(transformToState(response.data)));
    }, []);

    const handleSelectedCompany = (company: Company) => {
        setCompany(company)
        console.log("the company is being set: ", company)
        navigate(`/company/${company?.id}`);
    }
    return (
        <>
            <Grid container rowSpacing={4} sx={{ paddingBottom: 4 }}>
                <Grid size={8}>

                </Grid>
                <Grid size={12}>
                    {/* <CompanyTable
                        handleSelectedCompany={handleSelectedCompany} /> */}
                </Grid>
            </Grid>

        </>
    )
}
export default DashboardPage